module.exports = __webpack_public_path__ + "static/assets/4a81aab6478d252b66c78645701a25a3.svg";